import React, { FC, memo } from 'react';
import { VideoJS } from 'src/lib/videoJs';
import { useElearningVideoQuery } from 'src/common/hooks/elearning/useElearningVideoQuery';
import { VideoUnavailableOverlay } from 'src/common/components/Video/VideoUnavailableOverlay';
import { Loader } from 'src/common/components/Loader';
import { isEmpty } from 'ramda';
import { ApiError } from 'src/common/models/error';
import { VideoError } from 'src/common/models/videoErrorMap';

export interface UserElearningPageVideoHeaderProps {
  elearningId: number;
  coverPhotoUrl?: string;
}

export const ElearningVideo: FC<UserElearningPageVideoHeaderProps> = memo(
  ({ elearningId, coverPhotoUrl }) => {
    const { data, isLoading, error } = useElearningVideoQuery(elearningId);
    return (
      <>
        {isLoading && <Loader type="secondary" />}
        {((!isLoading && isEmpty(data?.url)) || error) && (
          <VideoUnavailableOverlay
            videoError={(error as ApiError<any, VideoError>)?.errors[0].errorCode}
          />
        )}
        {!isLoading && (
          <VideoJS
            bigButtonText="ZOBACZ ZAPOWIEDŹ"
            options={{
              poster: coverPhotoUrl,
              sources: data?.url
                ? [
                    {
                      src: data.url,
                      type: 'video/mp4',
                    },
                  ]
                : [],
            }}
          />
        )}
      </>
    );
  },
);
ElearningVideo.displayName = 'ElearningVideo';
